export default __webpack_public_path__ + "static/media/call.aa605b0a.svg";